import { useQuery } from '@tanstack/react-query';
import type {
  RequestFilteredRefundsList,
  ResourceApprovalsToReviewResponse,
} from './interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/subsidy/base';

export const useResourceApprovalsToReviewList = (
  requestParams: RequestFilteredRefundsList
) => {
  const response = useQuery<ResourceApprovalsToReviewResponse>({
    queryKey: [clientKeys.useResourceApprovalsToReview, requestParams],
    queryFn: async () => {
      const queryParams = new URLSearchParams();

      if (requestParams) {
        Object.entries(requestParams).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            queryParams.append(key, value.toString());
          }
        });
      }
      return await falconClient.get(
        `${baseUrl}/resource_approvals/to_review?${queryParams.toString()}`
      );
    },
  });

  const resourceApprovals = response?.data?.resource_approvals || [];
  const totalPages = response?.data?.metadata.total_pages || 0;
  const itemsPerPage = response?.data?.metadata.items_per_page || 10;
  const totalItems =
    response?.data?.metadata.total_items ?? totalPages * itemsPerPage;

  return {
    resourceApprovals,
    totalPages,
    totalItems,
    ...response,
  };
};
